import React, { useRef, useEffect, useState } from "react";
import "./services.scss";
import { useWindowSize } from "react-use";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { greyRightArrow, whiteRightArrow } from "../../source";

const Services = ({ servicesData }) => {
  const { width } = useWindowSize();
  const descRefs = useRef([]);
  const [isClicked, setIsClicked] = useState("right");

  useEffect(() => {
    // Initialize height to zero for all elements
    descRefs.current.forEach((ref) => {
      if (ref && width > 1080) {
        ref.style.height = "0px";
        ref.style.overflow = "hidden";
        // ref.style.transition = "height 0.3s ease";
      }
    });
  }, []);

  const handleMouseEnter = (index) => {
    const ref = descRefs.current[index];
    if (ref && width > 1080) {
      const height = ref.scrollHeight; // Get natural height of the element
      ref.style.height = `${height}px`; // Set to full height on hover
      //   console.log("isheight", height)
    }
  };

  const handleMouseLeave = (index) => {
    const ref = descRefs.current[index];
    if (ref && width > 1080) {
      ref.style.height = "0px"; // Collapse back to zero height on hover out
    }
  };

  return (
    <>
      <div className="services_container">
        <div className="my_container">
          {width > 992 ? (
            <div className="row services_row">
              {servicesData.map((item, i) => (
                <div
                  className="col-md-3 services_col"
                  key={i}
                  data-aos="fade-up"
                  data-aos-delay={100 * i}
                >
                  <div
                    className="services_box"
                    onMouseEnter={() => {
                      handleMouseEnter(i);
                    }} // Expand on hover
                    onMouseLeave={() => {
                      handleMouseLeave(i);
                    }} // Collapse on hover out>
                  >
                    <div className="img_wrapper">
                      <img
                        src={item.img}
                        alt={item.title}
                        width={378}
                        height={903}
                        className="services_img"
                      />
                    </div>
                    <div className="content_wrapper">
                      <h3 className="section_title36">{item.title}</h3>
                      <p
                        className={`section_desc`}
                        ref={(el) => (descRefs.current[i] = el)}
                      >
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="serivce_slider_container">
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                loop={true}
                modules={[Navigation]}
                navigation={{
                  nextEl: ".service_right_arrow",
                  prevEl: ".service_left_arrow",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 5,
                  },
                  577: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                  },
                }}
              >
                {servicesData.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className="services_box" data-aos="fade-up">
                      <div className="img_wrapper">
                        <img
                          src={item.imgMb}
                          alt={item.title}
                          width={343}
                          height={343}
                          className="services_img"
                        />
                      </div>
                      <div className="content_wrapper">
                        <h3 className="section_title36">{item.title}</h3>
                        <p className={`section_desc`}>{item.desc}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="arrow_container">
                <div
                  className={`arrow_wrapper service_left_arrow ${
                    isClicked === "left" ? "active" : ""
                  }`}
                  onClick={() => setIsClicked("left")}
                >
                  <img
                    src={
                      isClicked === "left" ? whiteRightArrow : greyRightArrow
                    }
                    alt="left arrow"
                    className="left_arrow"
                  />
                </div>
                <div
                  className={`arrow_wrapper service_right_arrow ${
                    isClicked === "right" ? "active" : ""
                  }`}
                  onClick={() => setIsClicked("right")}
                >
                  <img
                    src={
                      isClicked === "right" ? whiteRightArrow : greyRightArrow
                    }
                    alt="right arrow"
                    className="right_arrow"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Services;
